import { render, staticRenderFns } from "./FirstDiagnosticPage.vue?vue&type=template&id=cc2f8e72&scoped=true&"
import script from "./FirstDiagnosticPage.vue?vue&type=script&lang=js&"
export * from "./FirstDiagnosticPage.vue?vue&type=script&lang=js&"
import style0 from "./FirstDiagnosticPage.vue?vue&type=style&index=0&id=cc2f8e72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc2f8e72",
  null
  
)

export default component.exports